import {
  ActuatorModalityType,
  Slot,
  SlotStatus,
  ThermoActuatorType,
  DeviceDTO,
  ThermoRoomObjectDTO,
  SystemControlType,
} from '@/../client-generator/generated-clients/plants';
import {
  SlotRuleServiceType,
  WorkflowCallbackFunction,
} from './slots-assign-rules-interfaces';
import BaseSlotRuleService from './slots-assign-rules-service';

export default class AssignThermoSharedActuatorSlotRuleService extends BaseSlotRuleService {
  declare roomObject: ThermoRoomObjectDTO;

  constructor(
    roomObject: ThermoRoomObjectDTO,
    workflowCallback: WorkflowCallbackFunction
  ) {
    super(
      roomObject,
      -1,
      ThermoActuatorType.SharedValve,
      roomObject.actuatorModalityType ?? ActuatorModalityType.None,
      workflowCallback
    );
    this.slotRuleServiceType = SlotRuleServiceType.THERMO_HEATING_ACTUATORS;

    this._noOfAdjacent = this.getNoOfAdjacentSlots(
      roomObject.sharedSystemControlType ?? SystemControlType.None
    );
  }

  addOrUpdateSlot(
    slotViewModel: Slot,
    thermoActuatorType = ThermoActuatorType.None
  ) {
    super.addOrUpdateSlot(slotViewModel, ThermoActuatorType.SharedValve);
  }

  onSlotMessage(device: DeviceDTO, slot: Slot) {
    if (this.roomObject != null) {
      const tmpActuatorType = this.getCurrentThermoActuatorType(
        slot.thermoActuatorTypes,
        this.roomObject.id
      );
      if (
        slot.status == SlotStatus.Configured ||
        slot.status == SlotStatus.MarkedForLinking ||
        slot.status == SlotStatus.MarkedAdjacent
      ) {
        if (tmpActuatorType == ThermoActuatorType.SharedValve) {
          super.onSlotMessage(device, slot);
        }
      } else {
        super.onSlotMessage(device, slot);
      }
    }
  }

  isLimitationReached(slotsToBeMarked: Slot[] | null) {
    if (this.roomObject?.devices != null && slotsToBeMarked != null) {
      var noOfSelectedValves = this.roomObject.devices
        .flatMap((d) => d.slots)
        .filter((s) =>
          [ThermoActuatorType.SharedValve].includes(
            this.getCurrentThermoActuatorType(
              s?.thermoActuatorTypes,
              this.roomObject.id
            )
          )
        ).length;

      var noOfSlotsToBeAddedInParam = slotsToBeMarked.length;

      if (
        noOfSelectedValves + noOfSlotsToBeAddedInParam <=
        this.MaximumNoOfThermostatSlots
      ) {
        return false;
      }
      return true;
    }

    return false;
  }
}
